<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
    <v-text-field
      v-model="form.name"
      :rules="rules.name"
      type="text"
      label="Название группы"
    />

    <v-row>
      <v-col md="6" class="pt-0">
        <v-menu
          ref="menu1"
          v-model="dateMenuState"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateValue"
              :rules="rules.date"
              label="Дата события"
              persistent-hint
              prepend-icon="event"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dateValue"
            locale="ru"
            no-title
            :first-day-of-week="1"
            @input="dateMenuState = false"
          />
        </v-menu>
      </v-col>

      <v-col md="6" class="pt-0">
        <v-menu
          ref="menu"
          v-model="timeMenuState"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="timeValue"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="timeValue"
              :rules="rules.time"
              label="Время события"
              prepend-icon="access_time"
              readonly
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="timeMenuState"
            v-model="timeValue"
            format="24hr"
            full-width
            @click:minute="$refs.menu.save(timeValue)"
          />
        </v-menu>
      </v-col>
    </v-row>

    <div class="d-flex justify-end">
      <v-btn v-if="!isEdit" type="submit" color="success" dark>Создать группу</v-btn>
      <v-btn v-else type="submit" color="primary" dark>Сохранить изменения</v-btn>
    </div>
  </v-form>
</template>

<script>
import moment from 'moment';

const createDefaultForm = () => ({
  name: null,
  happenedAt: null,
});

const createDefaultRules = () => ({
  name: [
    v => !!v || 'Название слоя обязательно для заполнения',
  ],
  date: [
    v => !!v || 'Дата обязательное поле для заполнения',
  ],
  time: [
    v => !!v || 'Время обязательное поле для заполнения',
  ],
});

export default {
  name: 'layer-group-form',
  model: {
    event: 'change',
    prop: 'input',
  },
  props: {
    data: {
      type: Object,
      default: createDefaultForm,
    },
    isLoading: Boolean,
    isEdit: Boolean,
  },
  data: () => ({
    form: createDefaultForm(),
    rules: createDefaultRules(),
    valid: true,
    dateValue: null,
    timeValue: null,
    dateMenuState: false,
    timeMenuState: false,
  }),
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form = {
          ...this.form,
          ...value,
        };

        if (value.happenedAt) {
          const date = moment(value.happenedAt);
          this.dateValue = date.format('YYYY-MM-DD');
          this.timeValue = date.format('HH:mm');
        }
      },
    },
    form: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    dateValue: 'updateHappenedAt',
    timeValue: 'updateHappenedAt',
  },
  async created() {
    this.form = {
      ...this.form,
      ...this.data,
    };
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.form);
      }
    },

    updateHappenedAt() {
      if (this.dateValue && this.timeValue) {
        this.form.happenedAt = moment(`${this.dateValue}T${this.timeValue}`).toString();
      }
    },
  },
};
</script>
